import { FaPlus, FaSignOutAlt } from 'react-icons/fa';
import React from 'react';
import useLogin from './hooks/useLogin';
const HeaderComponent = () => {
  const { logout } = useLogin()
  return (
    <div className="bg-white shadow-md rounded-lg p-6 flex justify-between items-center mb-10">
      <div>
        <p className="text-gray-500">Templates</p>
        <h1 className="text-2xl font-bold">Templates</h1>
      </div>
      <div className="gap-10  flex justify-between items-center mb-10">
        <a
          href='/authors/new_template'
          className="bg-blue-500 text-white px-4 py-2 rounded-lg flex items-center space-x-2 hover:bg-blue-600 transition-all">
          <FaPlus />
          <span>Create Template</span>
        </a>
        <button
          onClick={() => {
            logout()
          }}
          className="bg-blue-500 text-white px-4 py-2 rounded-lg flex items-center space-x-2 hover:bg-blue-600 transition-all">
          <FaSignOutAlt />
          <span>Log Out</span>
        </button>
      </div>

    </div>
  );
};

export default HeaderComponent;
